// Utility functions for generating accurate structured data
// Includes XSS protection as recommended by Next.js documentation

export function sanitizeForJsonLd(str: string): string {
  return str
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/'/g, '\\u0027')
    .replace(/"/g, '\\u0022');
}

export function createSafeJsonLd(obj: any): string {
  return JSON.stringify(obj)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e');
}

export interface FAQItem {
  question: string;
  answer: string;
}

export interface BreadcrumbItem {
  name: string;
  url: string;
}

// Base organization data for SafeMonk
export const SAFEMONK_ORGANIZATION = {
  "@type": "Organization",
  "name": "SafeMonk",
  "url": "https://www.safemonk.com",
  "description": "Secure secret sharing with zero-knowledge encryption",
  "foundingDate": "2024",
  "industry": "Computer Security",
  "parentOrganization": {
    "@type": "Organization",
    "name": "Enoki Limited",
    "identifier": "6308321",
    "location": {
      "@type": "Place",
      "addressCountry": "New Zealand"
    }
  }
};

export const CURRENT_DATE = new Date().toISOString().split('T')[0];
export const PUBLISH_DATE = "2024-06-01"; // SafeMonk launch date